import { GenericRequestMessage, GenericResponseMessage } from './genericMessage';
import * as v100 from './jovo/v100';
import * as v110 from './jovo/v110';

const versionModules: Record<string, VersionModule> = {
    '1.0.0': v100,
    '1.1.0': v110,
};
const defaultVersion = '1.1.0';

interface VersionModule {
    parseRequest: (data: any) => GenericRequestMessage;
    parseResponse: (data: any) => GenericResponseMessage;
    buildRequest: (message: GenericRequestMessage) => any;
    buildResponse: (message: GenericResponseMessage) => any;
}

export const parseRequest = (data: any): GenericRequestMessage => {
    const versionModule = versionModules[data?.version];

    if (versionModule) {
        return versionModule.parseRequest(data);
    } else {
        throw {
            error: 'parseRequest: unknown jovo protocol version',
            data,
            version: data?.version,
        };
    }
};

export const parseResponse = (data: any): GenericResponseMessage => {
    const versionModule = versionModules[data?.version];

    if (versionModule) {
        return versionModule.parseResponse(data);
    } else {
        throw {
            error: 'parseResponse: unknown jovo protocol version',
            data,
            version: data?.version,
        };
    }
};

export const buildRequest = (
    message: GenericRequestMessage,
    version: string = defaultVersion
): any => {
    const versionModule = versionModules[version];

    if (versionModule) {
        return versionModule.buildRequest(message);
    } else {
        throw { error: 'buildRequest: unknown jovo protocol version', version, message };
    }
};

export const buildResponse = (
    message: GenericResponseMessage,
    version: string = defaultVersion
): any => {
    const versionModule = versionModules[version];

    if (versionModule) {
        return versionModule.buildResponse(message);
    } else {
        throw { error: 'buildResponse: unknown jovo protocol version', version, message };
    }
};
